import React from 'react';
import PropTypes from 'prop-types';
import classNames from 'classnames';
import Button from '../button';
import SwitchBase from '../switchBase';

const propTypes = {
  prefixCls: PropTypes.string,
  /** 标签文本 */
  label: PropTypes.node,
  /** 是否禁用 */
  disabled: PropTypes.bool,
  /** 选中状态（适用于受控组件） */
  checked: PropTypes.oneOfType([PropTypes.bool, PropTypes.string]),
  /** 选中状态默认值 */
  defaultChecked: PropTypes.oneOfType([PropTypes.bool, PropTypes.string]),
  /** 选中状态icon */
  checkedIcon: PropTypes.node,
  className: PropTypes.string,
  /** 未选中状态icon */
  uncheckedIcon: PropTypes.node,
  /** 获取input的ref */
  inputRef: PropTypes.func,
  /** 选中状态改变时的回调 function(e, checked) */
  onChange: PropTypes.func,
};
const defaultProps = {
  defaultChecked: false,
  prefixCls: 'ne-radio-button',
  disabled: false,
};

/**
 * RadioButton
 */
export default function RadioButton(props) {
  const { prefixCls, label, size, className, ...other } = props;
  return (
    <SwitchBase
      className={classNames(prefixCls, className)}
      label={(state, disabled) => (
        <Button
          className={`${prefixCls}-base`}
          component="span"
          active={state}
          disabled={disabled}
          size={size}
          {...other}>
          {label}
        </Button>
      )}
      size={size}
      {...other}
      checkedIcon=""
      inputType="radio"
    />
  );
}

RadioButton.propTypes = propTypes;
RadioButton.defaultProps = defaultProps;



// WEBPACK FOOTER //
// ./src/radio/RadioButton.jsx